import { environment } from "./environment";

const qaEndpoints = {
  backoffice: {
    environmentKey: "BO_URL",
    localUrl: "http://localhost:5140",
  },
  iot: {
    environmentKey: "API_URL",
    localUrl: "http://localhost:5039",
  },
  sso: {
    environmentKey: "SSO_URL",
    localUrl: "http://localhost:5038",
  },
} as const;

type QaService = keyof typeof qaEndpoints;

const isQaService = (value: string): value is QaService => value in qaEndpoints;

export const configureQaLocalEndpoints = () => {
  if (!OCT_QA_LOCAL_ENDPOINTS) return;

  const services = (new URLSearchParams(location.search).get("local") ?? "")
    .split(",")
    .filter(isQaService);

  for (const service of services) {
    const endpoint = qaEndpoints[service];
    environment[endpoint.environmentKey] = endpoint.localUrl;
  }
};
